<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue";
import AppSidebar from "./AppSidebar.vue";
import AppHeader from "./AppHeader.vue";
import CommandPalette from "./CommandPalette.vue";

const paletteOpen = ref(false);

function onKey(e: KeyboardEvent): void {
  // Cmd+K (Mac) or Ctrl+K (Win/Linux) — toggle palette.
  if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
    e.preventDefault();
    paletteOpen.value = !paletteOpen.value;
  }
}

onMounted(() => { window.addEventListener("keydown", onKey); });
onBeforeUnmount(() => { window.removeEventListener("keydown", onKey); });
</script>

<template>
  <div class="flex h-screen overflow-hidden bg-surface-50">
    <AppSidebar @open-palette="paletteOpen = true" />
    <!-- min-w-0: a flex item defaults to min-width:auto and won't shrink below
         its content. Safari/WebKit enforces this strictly, so without it this
         column stretched to its widest child (a table / the donut row) and the
         header's right side — the user name — was pushed past the viewport
         (horizontal scroll). Chrome was lenient; Safari was not. -->
    <div class="flex-1 flex flex-col overflow-hidden min-w-0">
      <AppHeader />
      <main class="flex-1 overflow-y-auto">
        <!-- ГОР.СКРОЛЛ / пустое место (фидбэк Игоря): раньше max-w-7xl (1280px)
             зажимал контент в узкую колонку, оставляя по бокам широких мониторов
             много пустоты. Теперь тянемся на всю ширину, мягко ограничивая лишь
             ультраширокие экраны (2560+) до 1920px ради читабельности строк.
             min-w-0 страхует от горизонтального скролла из-за вложенных таблиц. -->
        <div class="mx-auto w-full min-w-0 max-w-[1920px] px-6 py-8">
          <slot />
        </div>
      </main>
    </div>
    <CommandPalette :open="paletteOpen" @close="paletteOpen = false" />
  </div>
</template>
